import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';
import Button from '../../components/atoms/forms/Button';

const StyledDiv = styledComponent('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.colors.bgMuted,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: theme.radii.input,
  padding: theme.spacing.cardPadding,
  marginTop: theme.spacing.sectionGap,

  '& .sab-status': {
    fontSize: theme.sizes.smallFontSize,
    color: theme.colors.textBody,
  },
  '& .sab-status strong': {
    color: theme.colors.textDark,
  },
  '& .sab-success': {
    color: theme.colors.successText,
    fontWeight: theme.fontWeights.medium,
    marginLeft: theme.spacing.innerGap,
  },
});

function SaveAssignmentsBar({
  assignedCount,
  totalCount,
  isDirty,
  isSaving,
  saveSuccess,
  onSave,
}) {
  return (
    <StyledDiv>
      <span className="sab-status">
        <strong>
          {assignedCount} of {totalCount}
        </strong>{' '}
        routes assigned
        {isDirty && ' · unsaved changes'}
        {saveSuccess && !isDirty && (
          <span className="sab-success">✓ Assignments saved</span>
        )}
      </span>
      <Button
        variant="primary"
        onClick={onSave}
        disabled={!isDirty || isSaving}
        dataTestId="save-assignments"
      >
        {isSaving ? 'Saving…' : 'Save Assignments'}
      </Button>
    </StyledDiv>
  );
}

SaveAssignmentsBar.propTypes = {
  assignedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  saveSuccess: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
};

SaveAssignmentsBar.defaultProps = {
  saveSuccess: false,
};

export default SaveAssignmentsBar;
